module.exports = __webpack_public_path__ + "img/sutied.9b309272.png";